export class RNG {
    private a: number = 0;
    private b: number = 0;
    private c: number = 0;
    private d: number = 0;
    
    constructor(seed?: number) {
        this.seed(seed || Date.now());
    }
    
    seed(seed: number): void {
        this.a = seed;
        this.b = 0x9e3779b9;
        this.c = 0x6a09e667;
        this.d = 0xbb67ae85;
        
        for (let i = 0; i < 20; i++) {
            this.next();
        }
    }
    
    private next(): number {
        const t = this.b << 9;
        this.c = this.c ^ this.a;
        this.d = this.d ^ this.b;
        this.b = this.b ^ this.c;
        this.a = this.a ^ this.d;
        this.c = this.c ^ t;
        this.d = (this.d << 11) | (this.d >>> 21);
        return this.d >>> 0;
    }
    
    random(): number {
        return this.next() / 0xffffffff;
    }
    
    randomInt(min: number, max: number): number {
        return Math.floor(this.random() * (max - min + 1)) + min;
    }
    
    randomFloat(min: number, max: number): number {
        return this.random() * (max - min) + min;
    }
    
    pick<T>(array: T[]): T {
        return array[this.randomInt(0, array.length - 1)];
    }
    
    weighted<T>(items: T[], weights: number[]): T {
        const totalWeight = weights.reduce((sum, w) => sum + w, 0);
        let random = this.random() * totalWeight;
        
        for (let i = 0; i < items.length; i++) {
            random -= weights[i];
            if (random <= 0) {
                return items[i];
            }
        }
        
        return items[items.length - 1];
    }
    
    shuffle<T>(array: T[]): T[] {
        const result = [...array];
        for (let i = result.length - 1; i > 0; i--) {
            const j = this.randomInt(0, i);
            [result[i], result[j]] = [result[j], result[i]];
        }
        return result;
    }
    
    chance(probability: number): boolean {
        return this.random() < probability;
    }
}